module.exports = __webpack_public_path__ + "static/roboto-v29-latin-300-bf0f407102faf3a0b521d3b545f547a5.woff";